import { useMemo } from 'react';

import { OrganizationTypes } from '@/common/constants';
import { useCurrentOrganization } from '@/modules/core/hooks';

import { UseUndeliverableMailStatisticLogicParams } from '../UndeliverableMailStatistic.types';

export const useUndeliverableMailStatisticLogic = ({
  data,
}: UseUndeliverableMailStatisticLogicParams) => {
  const {
    observingOrganization: { type },
  } = useCurrentOrganization();

  const isHidden = useMemo(() => type === OrganizationTypes.system, [type]);

  const isDetailsLinkVisible = useMemo(() => type !== OrganizationTypes.system, [type]);

  const count = useMemo(() => data?.flaggedEmployeesCount || 0, [data?.flaggedEmployeesCount]);

  return {
    count,
    isDetailsLinkVisible,
    isHidden,
  };
};

export default useUndeliverableMailStatisticLogic;
